import React from 'react';
import LeadAPI from '../../api/LeadAPI';
import ContactAPI from '../../api/ContactAPI';
import Display from '../../util/Display';

class FieldModule extends React.Component {
  
  constructor(props) {
    super(props);
    this.LabelName = props.field.label_name;
    this.id = props.value.model_id;
    this.modelNo = props.value.model_no;
    this.state = { name: '' };
  }

  componentDidMount() {
    const tmp = () => {};
    if(this.modelNo === LeadAPI.ModelNo) LeadAPI.get(this.id, this.onRes, tmp, tmp);
    else if(this.modelNo === ContactAPI.ModelNo) ContactAPI.get(this.id, this.onRes, tmp, tmp);
  }

  onRes = res => { this.setState({ name: Display.ModelName(res) })};

  render() {
    return (
      <div className="col">
        <div className="form-group">
          <h5><label>{this.LabelName}</label> : <label className="mr-sm-2">{this.state.name}</label></h5>
        </div>
      </div>
    );
  }
}
export default FieldModule;